module.exports = __webpack_public_path__ + "static/wood-pellets-bags-bd6683528039ee90582eb2e122f37e42.jpg";